<i18n src='../i18n/main.json'></i18n>
<i18n src='../i18n/doc.json'></i18n>

<template>
<div id="doc" style="position: relative" class="container-fluid" v-if="dataReady">

  <doc-form ref="doc_form" :e_doc="e_doc"></doc-form>

  <div class="row">

    <button v-on:click="loadDocEditor();" class="btn btn-warning">
      {{ $t('edit_' + doctype_to_name[doc.doctype.id]) }}
    </button>
    &nbsp;
    <a :href="'/api/docs/'+ doc.id + '/pdf_printer'" target="_blank" class="btn btn-info">
      {{ $t('print') }}
    </a>
  </div>
  <br>

  <div v-if="dataReady" id="docHTML">
    <!-- <print-header></print-header> -->
    <div id="docHTMLinner" dir="rtl">
      <div class="docDetails">
        <h1>{{$t(doctype_to_name[doc.doctype.id])}}
          <span v-if="dataReady" style="color:crimson;text-decoration:underline;">{{ doc._serial }}</span>
          <span class="noPrint">&nbsp;סה"כ: </span>
          <span class="noPrint" v-if="dataReady" style="color:green;text-decoration:underline;">{{ parseFloat(doc.total).toFixed(2) }}</span>
        </h1>
        <div class="docDatew">
          <span dir="ltr">{{ $moment(doc.at).format('DD/MM/YYYY - HH:mm') }}</span>
        </div>
        <br/>
        <div class="row">
          <div class="col-md-2">

            <div>
              {{$t('name')}}:
              <strong>{{ doc.client.name }}</strong>
            </div>
            <div v-if="!!doc.client.tax_number">{{$t('tax_number')}}: {{ doc.client.tax_number }}</div>

          </div>

          <div class="col-md-2">
            <div v-if="!!doc.client.mobile_1st">{{$t('mobile')}}: {{ doc.client.mobile_1st }}</div>
            <div v-if="!!doc.client.mobile_2nd">{{$t('mobile')}}: {{ doc.client.mobile_2nd }}</div>
            <div v-if="!!doc.client.phone">{{$t('phone')}}: {{ doc.client.phone }}</div>
            <div v-if="!!doc.client.fax">{{$t('fax')}}: {{ doc.client.fax }}</div>
            <div v-if="!!doc.client.email">{{$t('email')}}:
              <a :href="doc.client.email">{{ doc.client.email }}</a>
            </div>
          </div>

          <div class="col-md-2">{{$t('address')}}:
            <br />{{ doc.address }}
          </div>

   <div class="col-md-2">{{$t('notes')}}:
            <br />{{ doc.notes }}
          </div>
        </div>
      </div>


      <div v-if="doc.itemlines.length > 0">
        <div class="row">
          <h2>{{ $t('items') }}</h2>
        </div>
        <div class="row" v-if="dataReady">

          <div class="itemlines col-md-12">
            <table class="table table-striped itemlines">
              <thead>
                <tr>
                  <th>{{ $t('sku') }}</th>
                  <th @click="sort('title')" class="sortable">
                    <i v-bind:class="get_th_Class('title')"></i> {{ $t('name') }}
                  </th>
                  <th></th>
                  <th>{{ $t('quantity') }}</th>
                  <!-- <th>{{ $t('cost') }}</th> -->
                  <th>{{ $t('price') }}</th>

                  <th>{{ $t('line_total') }}</th>
                  <th>{{ $t('notes') }}</th>

                </tr>
              </thead>
              <tbody>

                <tr v-for="(itemline, index) in doc.itemlines">
                  <td>{{ itemline.item.id != 635 ? itemline.item.sku : "--" }}</td>
                  <td>{{ itemline.item.id != 635 ? itemline.item.name : itemline.notes }}</td>
                  <td>{{ itemline.item.extra }}</td>
                  <td>{{ itemline.quantity }}</td>
                  <!-- <td>{{ itemline.cost }}</td> -->
                  <td>{{ itemline.price }}</td>
                  <td>{{ itemline.line_total }}</td>
                  <td>{{ itemline.item.id != 635 ? itemline.notes : "" }}</td>
                </tr>
                <tr>
                  <td colspan="7"></td>
                </tr>
                <tr>
                  <td colspan="4"></td>
                  <td>סה"כ</td>
                  <td>
                    <b>{{doc.total_base}}</b>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4"></td>
                  <td>הנחה %</td>
                  <td>
                    <b>{{doc.discount_rate / 100}}&nbsp;&nbsp;({{((doc.discount_rate / 100) * doc.total_base).toFixed(2)}})</b>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4"></td>
                  <td>מחיר לאחר הנחה</td>
                  <td>
                    <b>{{parseFloat(doc.total).toFixed(2)}}</b>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4"></td>
                  <td>מע"מ</td>
                  <td>{{(0.17 * doc.total).toFixed(2).replace(/\.0+$/, '')}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4"></td>
                  <td>סה"כ כולל מע"מ</td>
                  <td>
                    <b>{{((0.17 * doc.total) + (1 * doc.total)).toFixed(2).replace(/\.0+$/, '') }}</b>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- <print-footer></print-footer> -->
  </div>
</div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import DocForm from '../components/DocForm'

import Vue from 'vue'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash)

export default {
  components: {
    SweetModal,
    SweetModalTab,
    'doc-form': DocForm
  },
  ready() {
    // here is code that should be done first before vue render all authData
  },
  data() {
    return {
      doctype: null,
      doctypes: {
        orders: 1,
        price_quotes: 2
      },
      doctype_to_name: {
        1: 'order',
        2: 'price_quote'
      },
      output: null,
      e_doc: this.init_doc(),
      dataReady: false,
      items_options: [],
      errors: [],
      doc: [],
      books: [],
      currentSort: 'days_to_expiration',
      currentSortDir: 'desc',
      paymentMethods: {
        cash: this.$t('cash'),
        credit_card: this.$t('credit_card'),
        bank_transfer: this.$t('bank_transfer')
      },
      lineitem_serial: 0
    }
  },
  computed: {
    sortedBooks: function() {
      return this.books.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    }
  },
  created() {
    this.doctype = this.doctypes[this.$route.params.doctype] == null ? 0 : this.doctypes[this.$route.params.doctype]
    console.log(this.doctype)
    this.loadDoc()
    this.$i18n.locale = this.$store.getters.locale
    this.$i18n.silentTranslationWarn = true
  },
  init() {
    //this.showEditModal()
  },
  watch: {},

  /*     */
  methods: {
    print() {
      // Pass the element id here
      //this.$htmlToPaper('docHTML')
      let vm = this
      vm.$axios
        .get(`/api/docs/` + vm.$route.params.doc_id + '/pdf_printer', {
          headers: vm.authorization()
        })
        .then(response => {})
        .catch(e => {
          console.log(e)
          vm.errors.push(e)
          vm.PageSelectisDisabled = false
        })
    },
    init_doc: function() {
      return {
        isNew: false,
        client_id: null,
        client_id_processing: null,
        status: null,
        meta: null,
        accounting_ref: null,
        notes: null,
        itemlines: [],
        at: this.$moment().format('YYYY-MM-DD')
      }
    },
    loadDocEditor: function() {
      console.log('loadDocEditor..')
      console.log(this.e_doc)
      this.$refs.doc_form.$refs.edit_doc_modal.open()
    },

    adjust_manual_pirce: function(e, itemline) {
      console.log(itemline)
      itemline.price = (itemline.effective_price / 1.17).toFixed(2).replace(/\.0+$/, '')
    },
    onSearch(search, loading) {
      loading(true)
      this.getItemsbyAutocomplete(loading, search, this)
    },
    getItemsbyAutocomplete: Vue._.debounce((loading, search, vm) => {
      fetch(`/api/items/autocomplete?query=${search}`, { headers: vm.authorization() }).then(res => {
        res.json().then(json => (vm.items_options = json.items))
        loading(false)
      })
    }, 350),
    addItemline: function() {
      this.lineitem_serial++

      this.editor.itemlines.push({
        quantity: 1,
        price: 0,
        notes: null,
        item: { id: null },
        item_id_processing: { value: null, label: null, cost: 0, price: 0 },
        delete: false,
        item_id: null,
        line_total: 0,
        cost: null,
        _serial: this.lineitem_serial
      })
    },
    deleteItemline: function(index) {
      this.editor.itemlines[index].delete = true
    },

    addPayment: function() {
      this.doc.payments.push({
        ref: null,
        notes: null,
        method: null,
        amount: null
      })
    },
    deletePayment: function(index) {
      this.doc.payments[index].delete = true
    },

    showEditModal() {},
    hideEditModal() {
      console.log('hidden')

      this.$modal.hide('edit-doc')
    },

    resetEditor() {
      console.log('hidden')
      this.e_doc = []
      this.loadDoc()
    },
    get_th_Class: function(sort_by) {
      let tr_class = null
      if (sort_by === this.currentSort) {
        tr_class = this.currentSortDir === 'asc' ? 'ti-angle-up' : 'ti-angle-down'
      }
      return tr_class
    },
    sort: function(s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    loadDoc: function(e) {
      let vm = this
      this.$axios
        .get(`/api/docs/` + vm.$route.params.doc_id, {
          headers: vm.authorization()
        })
        .then(response => {
          vm.doc = response.data.doc

          vm.doc.itemlines.forEach(function(lineitem, index) {
            this[index].item_id_processing = { value: null, label: null, cost: 0, price: 0 }
          }, vm.doc.itemlines)

          vm.doc.itemlines = Vue._.sortBy(vm.doc.itemlines, 'id')

          // console.log(vm.editor)
          vm.e_doc = JSON.parse(JSON.stringify(vm.doc))
          vm.e_doc.isNew = false
          console.log(vm.e_doc)
          vm.dataReady = true
        })
        .catch(e => {
          // console.log(e)
          vm.errors.push(e)
          vm.PageSelectisDisabled = false
        })
    },
    /*
    save_doc: function(status) {
      var vm = this
      vm.dataReady = false
      var adjusted_itemlines = []

      vm.editor.itemlines.filter(function(value, key) {
        if (value.item_id_processing !== null && typeof value.item_id_processing === 'object') {
          value.item_id = value.item.id === null ? value.item_id_processing.value : value.item_id
          value.cost = value.cost === null ? value.item_id_processing.cost : value.cost
        }

        if (value.item_id) {
          adjusted_itemlines.push(value)
        }
      })

      let doc = vm.editor
      doc.itemlines = adjusted_itemlines

      this.$axios
        .put(
          `/api/docs/` + vm.editor.id,
          {
            doc
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          vm.loadDoc()
          //console.log(response)
          vm.$refs.edit_doc_modal.close()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
*/
    keymonitor: function(event) {
      if (event.key == 'Enter') {
      }
    }
  }
}
</script>

<style lang="scss">
@import './sass/doc.scss';
/*
@media print {
thead { display: table-header-group; }
tfoot { display: table-footer-group; }
}
*/
</style>




  <!-- <flash-message variant="success"></flash-message> -->

  <!-- <button class='btn btn-info edit' v-on:click="$refs.edit_doc_modal.open()">{{$t('edit_doc')}}</button> -->

  <!-- <sweet-modal ref="edit_doc_modal" v-on:close="resetEditor">


    <h2>{{$t('edit_doc')}}</h2>


    <div class="row">
      <div class="col-md-3">
        <div>{{$t('date')}}:
          <span dir="ltr">{{ $moment(editor.at).format('DD/MM/YYYY - HH:mm') }}</span>
        </div>
        <div>{{$t('client')}}: {{editor.client.name}}</div>

      </div>

      <div class="form-group col-md-2">
        <label for="editor_accounting_ref">{{$t('accounting_ref')}}</label>
        <input type="text" id="editor_accounting_ref" v-model="editor.accounting_ref" placeholder="" class="form-control" />
      </div>


      <div class="form-group col-md-4">
        <label for="editor_notes">{{$t('notes')}}</label>
        <textarea id="editor_notes" v-model="editor.notes" placeholder="" class="form-control"></textarea>
      </div>


    </div>
    <div class="form-group">
      <h2>{{$t('itemlines')}}</h2>
      <table class="table table-striped">
        <thead>
          <tr class="row">
            <th class="col-md-4">{{$t('name')}}</th>
            <th class="col-md-1">{{$t('quantity')}}</th>
            <th class="col-md-1">{{$t('cost')}}</th>
            <th class="col-md-1">{{$t('price')}}</th>
            <th class="col-md-1">{{$t('total')}}</th>
            <th class="col-md-3">{{$t('notes')}}</th>
            <th class="col-md-1"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itemline, index) in editor.itemlines" v-if="itemline.delete !== true" class="row">
            <td v-if="itemline.item.id === null" class="col-md-4">
              <v-select @input="set_item_data(itemline._serial, $event)" dir="rtl" v-model="itemline.item_id_processing" label="label"
                :filterable="false" :options="items_options" @search="onSearch">
                <template slot="no-options">
                  {{$t('type_to_search')}}..
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.label }}
                  </div>
                </template>
                <template slot="selected-option" scope="option">
                  <div class="selected d-center">
                    {{ option.label }}
                  </div>
                </template>
              </v-select>
            </td>
            <td class="col-md-4" v-else>({{itemline.item.sku}}) {{itemline.item.name}}</td>

            <td class="col-md-1">
              <input class="form-control _ltr" v-model="itemline.quantity">
            </td>

            <td class="col-md-1">
              <div style="margin-top: 5pt;">
                {{itemline.item.id === null ? itemline.item_id_processing.cost : itemline.cost}}
              </div>
            </td>

            <td class="col-md-1">
              <input class="form-control _ltr" v-model="itemline.price">
            </td>

            <td class="col-md-1">
              <input class="form-control _ltr" v-model="itemline.line_total">
            </td>
            <td class="col-md-3">
              <input class="form-control _ltr" v-model="itemline.notes">
            </td>
            <td>
              <button class="btn btn-danger" @click="deleteItemline(index)">
                {{$t('delete')}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-info" @click="addItemline">{{$t('add_itemline')}}</button>
    </div>


    <div class="form-group">
      <button class='btn btn-success' v-on:click="save_doc">{{$t('save')}}</button>
    </div>

  </sweet-modal> -->